import React from 'react';
import Link from 'next/link';

import {
  PRIVACY_ROUTER_PATH,
  TERMS_ROUTER_PATH,
} from '@/constants/router-path';
import { getYear } from '@/utils/datetime';

const FOOTER_LINK = [
  {
    name: '用户协议',
    href: TERMS_ROUTER_PATH,
  },
  {
    name: '隐私政策',
    href: PRIVACY_ROUTER_PATH,
  },
];

const Footer = () => {
  return (
    <footer className="text-xs text-black/85 pb-26 flex items-center justify-center gap-x-4 tablet:text-sm tablet:gap-x-7 tablet:pb-4">
      <span>Copyright © {getYear()} tanzhi.cn</span>
      {FOOTER_LINK.map(({ name, href }) => (
        <Link key={href} href={href}>
          {name}
        </Link>
      ))}
    </footer>
  );
};

export default Footer;
